// Flip this to true to re-enable the demo account walkthrough.
export const DEMO_TOUR_FEATURE_ENABLED = false;
export const DEMO_TOUR_ENABLED_KEY = "mongerDemoTourEnabled";
export const DEMO_TOUR_STATE_KEY = "mongerDemoTourState";

export const clearDemoTourProgress = () => {
  window.localStorage.removeItem(DEMO_TOUR_ENABLED_KEY);
  window.localStorage.removeItem(DEMO_TOUR_STATE_KEY);
};

export const stopDemoTour = () => {
  window.localStorage.removeItem(DEMO_TOUR_ENABLED_KEY);
};

export const startDemoTour = () => {
  if (!DEMO_TOUR_FEATURE_ENABLED) {
    clearDemoTourProgress();
    return;
  }

  window.localStorage.setItem(DEMO_TOUR_ENABLED_KEY, "true");
  window.localStorage.removeItem(DEMO_TOUR_STATE_KEY);
};
